import { LogsRegistry } from '@app/pages/SalesFunnels/LogsRegistry';

import {
  EditSalesFunnel,
  EditSalesFunnelPageHeader,
} from '@pages/SalesFunnels/EditSalesFunnel';
import {
  SalesFunnels,
  SalesFunnelsPageHeader,
} from '@pages/SalesFunnels/SalesFunnelsRegistry';
import {
  ViewSalesFunnel,
  ViewSalesFunnelPageHeader,
} from '@pages/SalesFunnels/ViewSalesFunnel';

export {
  SalesFunnels,
  SalesFunnelsPageHeader,
  ViewSalesFunnel,
  ViewSalesFunnelPageHeader,
  EditSalesFunnel,
  EditSalesFunnelPageHeader,
  LogsRegistry,
};
